module.exports = __webpack_public_path__ + "img/mono_21.f4f749d1.png";